export const projects = [
    {
        name: "CryptoScan Pro",
        description: "Real-time cryptocurrency analytics platform with Live WebSocket integration for sub-second price updates and a custom automated price alert system.",
        github: "https://github.com/akkii02/cryptopro",
        deploy: "https://cryptopro-six.vercel.app/",
        language: "React.js, Node.js, WebSockets, MongoDB, Docker",
        stars: 10,
        forks: 2,
        type: "personal"
    },
    {
        name: "Closed Banking Wallet",
        description: "Secure closed banking wallet with internal fund transfers, wallet top-up, and real-time transaction history. Features JWT auth and RBAC.",
        github: "https://github.com/akkii02/banking-wallet",
        language: "React.js, Node.js",
        stars: 12,
        forks: 4,
        type: "company",
        companyName: "Vidya Online Services"
    },
    {
        name: "TokBox AI Calling Agent",
        description: "AI-powered calling assistant using Twilio and Plivo, managing 1,000+ concurrent calls with optimized Node.js architecture.",
        github: "https://github.com/akkii02/tokbox-ai-agent",
        language: "React.js, Node.js, AI",
        stars: 18,
        forks: 7,
        type: "company",
        companyName: "Provaantech Pvt Ltd"
    },
    {
        name: "Hotel Booking App",
        description: "Full-stack hotel booking platform with Firebase authentication, CRUD operations, and a responsive Tailwind CSS UI.",
        github: "https://github.com/akkii02/hotel-booking-app",
        language: "React.js, Node.js, Firebase",
        stars: 8,
        forks: 3,
        type: "personal"
    },
    {
        name: "Prohirex Hiring Platform",
        description: "End-to-end MERN recruitment platform with job search, application tracking, and employer/job seeker dashboards.",
        github: "https://github.com/akkii02/prohirex",
        language: "MERN Stack",
        stars: 15,
        forks: 5,
        type: "company",
        companyName: "Provaantech Pvt Ltd"
    },

    {
        name: "Hackathon Web App",
        description: "Dashboard app for organizers to create and manage hackathons. Built with React and Node.js.",
        github: "https://github.com/akkii02/hackathon_app",
        language: "React.js, Node.js",
        stars: 10,
        forks: 2,
        type: "personal"
    },
    {
        name: "Mail Box Client",
        description: "Complete mail management system with a user-friendly frontend dashboard and secure login.",
        github: "https://github.com/akkii02/mail-box-client",
        language: "React.js, Node.js",
        stars: 7,
        forks: 1,
        type: "personal"
    },
];

